var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgViewactionblock = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.1667C4.04665 15.1667 0.833313 11.9533 0.833313 8.00001C0.833313 4.04668 4.04665 0.833344 7.99998 0.833344C11.9533 0.833344 15.1666 4.04668 15.1666 8.00001C15.1666 11.9533 11.9533 15.1667 7.99998 15.1667ZM7.99998 1.83334C4.59998 1.83334 1.83331 4.60001 1.83331 8.00001C1.83331 11.4 4.59998 14.1667 7.99998 14.1667C11.4 14.1667 14.1666 11.4 14.1666 8.00001C14.1666 4.60001 11.4 1.83334 7.99998 1.83334Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26664 13.1667C3.13998 13.1667 3.01331 13.12 2.91331 13.02C2.71998 12.8267 2.71998 12.5067 2.91331 12.3133L12.2466 2.97999C12.44 2.78666 12.76 2.78666 12.9533 2.97999C13.1466 3.17332 13.1466 3.49333 12.9533 3.68666L3.61998 13.02C3.51998 13.12 3.39331 13.1667 3.26664 13.1667Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewactionblock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/viewactionblock.4ec383b7.svg";
export { ForwardRef as ReactComponent };